import { render, staticRenderFns } from "./LeadShortlist.vue?vue&type=template&id=7c129517&"
import script from "./LeadShortlist.vue?vue&type=script&lang=js&"
export * from "./LeadShortlist.vue?vue&type=script&lang=js&"
import style0 from "./LeadShortlist.vue?vue&type=style&index=0&id=7c129517&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports